<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">{{data.no}}</button>
  <button mat-raised-button [mat-dialog-close]="true" color="primary" cdkFocusInitial>{{data.yes}}</button>
</div>